module.exports = __webpack_public_path__ + "img/logo-radio-hertz.d3296100.png";